module.exports = __webpack_public_path__ + "static/img/report.467227a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/report.png
// module id = Hb6g
// module chunks = 1